import {Component, Input} from '@angular/core';

// Loja criada pela MIA Gestor com a implantação em curso: no lugar do cardápio vazio,
// avisa que a loja ainda está sendo preparada e mostra ao dono o que falta.
@Component({
  selector: 'app-loja-em-criacao',
  templateUrl: './loja-em-criacao.component.html',
  styleUrls: ['./loja-em-criacao.component.scss']
})
export class LojaEmCriacaoComponent {
  @Input() empresa: any;

  get etapas() {
    const checklist = this.empresa?.lojaEmCriacao?.checklist || {};

    return [
      {titulo: 'Dados da loja', descricao: 'Nome, endereço e horários', situacao: checklist.empresa},
      {titulo: 'Cardápio', descricao: 'Produtos, preços e fotos', situacao: checklist.cardapio},
      {titulo: 'Formas de entrega', descricao: 'Delivery, retirada e taxas', situacao: checklist.formasEntrega},
      {titulo: 'Publicação', descricao: 'Link da loja no ar para os clientes', situacao: checklist.link},
    ];
  }

  get requerAtencao(): boolean {
    return !!this.empresa?.lojaEmCriacao?.requerAtencao;
  }

  rotulo(situacao: string): string {
    switch (situacao) {
      case 'CONCLUIDO':
      case 'DISPONIVEL':
        return 'Concluído';
      case 'EM_ANDAMENTO':
        return 'Em andamento';
      case 'DNS_PENDENTE':
        return 'Publicando';
      case 'ERRO':
        return 'Precisa de atenção';
      default:
        return 'Pendente';
    }
  }

  classe(situacao: string): string {
    switch (situacao) {
      case 'CONCLUIDO':
      case 'DISPONIVEL':
        return 'concluido';
      case 'EM_ANDAMENTO':
      case 'DNS_PENDENTE':
        return 'andamento';
      case 'ERRO':
        return 'erro';
      default:
        return 'pendente';
    }
  }
}
